"use strict";
function renderProductDetails(container, details) {
    try {
        const sections = [];
        if (details.instructions) {
            sections.push(`
        <div class="product-detail-section">
          <h3>Instructions</h3>
          <div class="detail-content">
            <a href="${details.instructions}" target="_blank" rel="noopener">View Instructions</a>
          </div>
        </div>
      `);
        }
        if (details.installationVideo) {
            sections.push(`
        <div class="product-detail-section">
          <h3>Installation Video</h3>
          <div class="detail-content">
            <a href="${details.installationVideo}" target="_blank" rel="noopener">Watch Installation Video</a>
          </div>
        </div>
      `);
        }
        if (details.featuresHtml) {
            sections.push(`
        <div class="product-detail-section">
          <h3>Features</h3>
          <div class="detail-content">
            ${details.featuresHtml}
          </div>
        </div>
      `);
        }
        if (details.features &&
            Array.isArray(details.features) &&
            details.features.length > 0) {
            const featuresList = details.features
                .map((feature) => `<li>${window.escapeHtml(feature)}</li>`)
                .join("");
            sections.push(`
        <div class="product-detail-section">
          <h3>Additional Features</h3>
          <div class="detail-content">
            <ul class="features-list">
              ${featuresList}
            </ul>
          </div>
        </div>
      `);
        }
        if (sections.length === 0) {
            container.innerHTML = "";
            return;
        }
        const html = `
      <div class="product-details-block">
        <h2>Product Details</h2>
        ${sections.join("")}
      </div>
    `;
        container.innerHTML = html;
    }
    catch (e) {
        console.error("Render product details error", e);
        container.innerHTML = "<p>Error rendering product details.</p>";
    }
}
// Initialize Product Details
(async function () {
    const detailsContainer = document.getElementById("bnr-product-details");
    if (detailsContainer) {
        const gid = detailsContainer?.dataset?.productGid;
        if (gid) {
            try {
                const version = "2025-10";
                const token = "ecbbf53ca75d6df11c96dd3da02cdc8e";
                const query = `
          query ProductDetails($id: ID!) {
            product(id: $id) {
              metafields(first: 10, namespace: "custom") {
                nodes {
                  key
                  value
                }
              }
            }
          }
        `;
                const res = await fetch(`/api/${version}/graphql.json`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": token,
                    },
                    body: JSON.stringify({
                        query,
                        variables: { id: `gid://shopify/Product/${gid}` },
                    }),
                });
                if (res.ok) {
                    const { data } = (await res.json());
                    const product = data?.product;
                    if (product) {
                        const metafields = product.metafields?.nodes || [];
                        const details = {
                            instructions: metafields.find((m) => m.key === "instructions")?.value ||
                                undefined,
                            installationVideo: metafields.find((m) => m.key === "installation_video")
                                ?.value || undefined,
                            featuresHtml: metafields.find((m) => m.key === "features_html")?.value ||
                                undefined,
                            features: metafields.find((m) => m.key === "features")?.value
                                ? JSON.parse(metafields.find((m) => m.key === "features").value)
                                : undefined,
                        };
                        renderProductDetails(detailsContainer, details);
                    }
                }
            }
            catch (e) {
                console.error("Product details error", e);
            }
        }
    }
})();
